import { WorkspacePendingUsersSettings } from '@/Workspaces/Settings/WorkspacePendingUsersSettings'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/workspace/$workspaceId/settings/pendingUsers',
)({
  component: RouteComponent,
})

function RouteComponent() {
  return <WorkspacePendingUsersSettings />
}
